import React from 'react';
import loadable from '@loadable/component';

const OptIn = loadable(() => import('features/Email/OptIn/OptInContainer'));

export const OptInRoute = () => ({
  path: '/email/opt-in/:token',
  indexRoute: {
    component: props => <OptIn {...props} />,
  },
});
